'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./ModalCloseButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalCloseButton = function ModalCloseButton(_ref) {
    var close = _ref.close;

    if (!close) return null;

    return _react2.default.createElement(
        _Button2.default,
        { onClickFn: close, className: 'ModalCloseButton' },
        _react2.default.createElement(_Icon2.default, { name: 'close-x' })
    );
};

ModalCloseButton.propTypes = {
    close: _propTypes2.default.func
};

exports.default = ModalCloseButton;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/ModalCloseButton.js
// module id = 1915
// module chunks = 0